<section class="sav-blog-categories-page">
  <header class="sav-blog-categories-hero">
    <div class="sav-blog-categories-hero-container">
      <app-breadcrumb [items]="crumbs" />
      <div class="sav-blog-categories-hero-inner">
        @if (pageH1()) {
          <h1 class="sav-blog-categories-hero-title">{{ pageH1() }}</h1>
        } @else {
          <h1 class="sav-blog-categories-hero-title">Browse Blog<br /><span>Categories</span></h1>
        }
        <p class="sav-blog-categories-hero-description">
          {{
            pageShortDescription() ||
              'Explore all blog categories to find coupon guides, shopping tips, brand deals, and savings strategies tailored to your interests.'
          }}
        </p>

        <div class="sav-blog-categories-search">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            ></path>
          </svg>
          <input
            type="search"
            placeholder="Search categories..."
            aria-label="Search blog categories"
            [value]="searchQuery()"
            (input)="onSearchInput($any($event.target).value)"
          />
        </div>
      </div>
    </div>
  </header>

  <section class="sav-blog-categories-list">
    <div class="sav-blog-categories-grid-container">
      <div class="sav-blog-categories-grid">
        @for (category of visibleCategories(); track category.id) {
          <a class="sav-blog-category-card" [routerLink]="['/blogs', category.slug]">
            <span class="sav-blog-category-icon" aria-hidden="true" [innerHTML]="category.iconHtml">
            </span>
            <!-- h2: these cards are the page's primary content, sitting directly under its H1.
                 As h3 they skipped a level — the page had no h2 at all before them. -->
            <h2>{{ category.name }}</h2>
            <p>{{ category.postCount }} Blogs &amp; Guides</p>
          </a>
        } @empty {
          <div class="sav-blog-categories-empty">
            {{ isSearching() ? 'Searching categories...' : 'No blog categories found.' }}
          </div>
        }
      </div>
    </div>
  </section>

  @if (longDescriptionHtml()) {
    <section class="sav-blog-categories-content">
      <div class="sav-blog-categories-grid-container">
        <app-longform-content [heading]="pageH2()" [html]="longDescriptionHtml()" />
      </div>
    </section>
  }
</section>
